<template>
    <div class="training-detail">
        <div class="training-detail__overlay">
            <div class="training-detail__information">
                <div class="training-detail__title">
                    {{ assignment.course_title }}
                </div>

                <div
                    class="training-detail__description"
                    v-html="assignment.description"
                ></div>

                <div class="training-detail__buttons">
                    <a
                        v-if="!isCompleted"
                        role="button"
                        target="_blank"
                        class="btn btn--primary btn--big"
                        :href="
                            route('tenant.trainings.process', {
                                course: assignment.course_id,
                            })
                        "
                    >
                        {{
                            isPending
                                ? trans('trainings.button.start')
                                : trans('trainings.button.continue')
                        }}
                    </a>

                    <a
                        v-if="isCompleted && isCertifiable"
                        role="button"
                        class="btn btn--primary btn--big"
                        :href="
                            route('tenant.trainings.certificate', {
                                course: assignment.course_id,
                            })
                        "
                    >
                        {{ trans('trainings.button.certificate') }}
                    </a>
                </div>
            </div>

            <div class="training-detail__progress" id="progressbar"></div>
        </div>

        <div
            class="training-detail__overlay training-detail__overlay--column h:margin-top-10"
            v-if="isCompleted"
        >
            <div class="training-detail__title">
                {{ trans('trainings.label.course_completed') }}
            </div>

            <div class="training-detail__description">
                <span
                    v-html="
                        trans('trainings.label.course_completed_description', {
                            endOfCurrentPeriod: assignment.end_of_period,
                        })
                    "
                ></span
                ><br />
                <span
                    v-if="assignment.next_assignment_at"
                    v-html="
                        trans(
                            'trainings.label.course_completed_next_assignment',
                            { nextAssignmentAt: assignment.next_assignment_at }
                        )
                    "
                ></span>
            </div>
        </div>
        <div
            class="training-detail__overlay training-detail__overlay--column h:margin-top-10"
            v-if="isCompleted && feedbackUrl && locale == 'de'"
        >
            <div class="training-detail__title">
                Ihre Meinung ist uns wichtig!
            </div>
            <div class="training-detail__description">
                <span>
                    Wie hat Ihnen die Unterweisung gefallen? Nehmen Sie jetzt an
                    unserer kurzen Umfrage teil.
                </span>
            </div>
            <div class="training-detail__buttons h:margin-bottom-5">
                <a
                    role="button"
                    target="_blank"
                    class="btn btn--primary btn--big"
                    :href="feedbackUrl"
                >
                    ZUR MEINUNGSUMFRAGE
                </a>
            </div>
        </div>

        <div
            class="training-detail__overlay training-detail__overlay--column h:margin-top-10 h:margin-bottom-10"
        >
            <div class="training-detail__title">
                {{ trans('trainings.label.learning_contents') }}
            </div>

            <div>
                <training-learning-content-tiles
                    :assignment="assignment"
                    :course-progress="assignment.courseProgress"
                    :learning-contents="assignment.learningContents"
                >
                </training-learning-content-tiles>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['courseId', 'locale'],

    data() {
        return {
            assignment: [],
            progressbar: null,
            myTimer: null,
        };
    },

    computed: {
        isPending() {
            return this.assignment.status == 'pending';
        },

        isCompleted() {
            return this.assignment.status == 'completed';
        },

        isCertifiable() {
            return this.assignment.is_certifiable;
        },

        feedbackUrl() {
            switch (this.courseId) {
                case 1: // Allgemeine Fahrerunterweisung PKW
                    return 'https://forms.office.com/e/URmqQcYX5J';
                case 62: // Homeoffice (mobile Arbeit)
                    return 'https://forms.office.com/e/50jjPVGLtk';
                case 2: // Allgemeiner Arbeitsschutz
                    return 'https://forms.office.com/e/vBtc8ETLQK';
                case 52: // Allgemeine Fahrerunterweisung PKW inkl. Zusatzmodul E-Fahrzeuge
                    return 'https://forms.office.com/e/NtHb69uRXG';
                case 4: // Bildschirmarbeitsplatz
                    return 'https://forms.office.com/e/sxDk32fwp7';
                case 68: // Allgemeiner Arbeitsschutz Büro – Basismodul A
                    return 'https://forms.office.com/e/1fQfhGqDeW';
                case 70: //Allgemeiner Arbeitsschutz Büro – Basismodul B
                    return 'https://forms.office.com/e/3xDe4LtjVz';
                case 3: // Allgemeiner Datenschutz
                    return 'https://forms.office.com/e/2EpXHXL1ZQ';
                case 21: // Qualifizierung für Arbeiten an Fahrzeugen mit HV-Systemen
                    return 'https://forms.office.com/e/6ahQ30gRi4';
            }
            return null;
        },
    },

    methods: {
        fetch() {
            axios
                .get(this.route('tenantapi.trainings.show', this.courseId))
                .then(({ data }) => {
                    let updateProgressbar =
                        this.assignment.progress_in_percent !=
                        data.data[0].progress_in_percent;

                    this.assignment = data.data[0];

                    // Initialize progress bar
                    if (!this.progressbar) {
                        this.initializeProgressbar();
                    }

                    // Update progress bar
                    if (updateProgressbar) {
                        this.progressbar.animate(
                            this.assignment.progress_in_percent
                        );
                    }

                    // Stop fetching data if course is completed
                    if (this.isCompleted) {
                        clearInterval(this.myTimer);
                    }
                });
        },

        updateStatus() {
            this.myTimer = setInterval(() => this.fetch(), 5000);
        },

        initializeProgressbar() {
            const ProgressBarLib = require('progressbar.js');

            this.progressbar = new ProgressBarLib.Circle('#progressbar', {
                color: '#FFEA82',
                trailColor: '#F2F2F2',
                trailWidth: 1,
                duration: 1500,
                easing: 'easeInOut',
                strokeWidth: 8,
                from: { color: '#f19933', a: 0 },
                to: { color: '#57ab27', a: 1 },
                // Set default step function for all animate calls
                step: (state, circle) => {
                    circle.path.setAttribute('stroke', state.color);

                    var value = Math.round(circle.value() * 100);
                    circle.setText(
                        '<div style="text-align:center">' +
                            value +
                            ' %<div style="font-size: 22px; font-weight: normal;">' +
                            this.trans('trainings.label.passed') +
                            '</div>'
                    );
                },
            });
            this.progressbar.text.style.fontFamily = 'Arial, sans-serif';
            this.progressbar.text.style.fontSize = '64px';
            this.progressbar.text.style.fontWeight = 'bold';
            this.progressbar.text.style.color = '#585858';

            this.progressbar.animate(this.assignment.progress_in_percent);
        },
    },

    mounted() {
        this.fetch();
        this.updateStatus();
    },
};
</script>
